import { TabToStateMap } from "@views/products/enums/productStatusEnum";
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(['getFoundInStatuses']),
  },
  methods: {
    applyFoundSearch() {
      const wanted = TabToStateMap[this.activeTab];
      let found;

      if (Array.isArray(wanted)) {
        found = this.getFoundInStatuses.find(i => wanted.includes(i.status));
      } else {
        found = this.getFoundInStatuses.find(i => i.status === wanted);
      }

      if (!found) return;

      if ('filterOffers' in this) this.filterOffers = found.search
      if ('filter'       in this) this.filter       = found.search
    }
  }
}
